/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://6igyj104ya.execute-api.us-east-1.amazonaws.com/prodsix",
            "region": "us-east-1"
        },
        {
            "name": "restapi",
            "endpoint": "https://1bfljmam4c.execute-api.us-east-1.amazonaws.com/prodsix",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://2dthgsi2mjfzjfwl3te4b7zrzm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:77b11b1f-f77f-4c00-a8a4-aad222e78fb7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ZLHCCW9Uj",
    "aws_user_pools_web_client_id": "7s7u3tajbi8033bsh494qv22qm",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_content_delivery_bucket": "babtl-20240101215828-hostingbucket-prodsix",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d503sllbzldf6.cloudfront.net"
};


export default awsmobile;
